import { render, staticRenderFns } from "./GridGamesScore.vue?vue&type=template&id=b408812e&scoped=true&"
import script from "./GridGamesScore.vue?vue&type=script&lang=js&"
export * from "./GridGamesScore.vue?vue&type=script&lang=js&"
import style0 from "./GridGamesScore.vue?vue&type=style&index=0&id=b408812e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b408812e",
  null
  
)

export default component.exports